/**
 * The three fixed product caps.
 *
 * These come from the brief as product constants and are deliberately NOT settings. They are
 * enforced in three layers that a settings row could not reach without being weakened: a Zod schema
 * here, a database CHECK constraint, and a trigger. Making them editable would mean raising the
 * setting and getting a raw trigger violation on the sixth upload, or lowering it and having
 * nothing happen at all.
 *
 * Every layer derives from these constants, and a `db` test reads the CHECK constraint and the
 * trigger definition out of `information_schema` and compares them against these numbers, so the
 * three layers cannot drift apart without a gate going red.
 */
/** At most five `active` images per person. A sixth upload is refused, not queued. */
export const MAX_ACTIVE_IMAGES_PER_PERSON = 5;
/** At most ten operator-added ad-hoc fields per person. */
export const MAX_ADHOC_FIELDS_PER_PERSON = 10;
/**
 * At most 5,000 characters in a long-text value.
 *
 * The brief states it as the notes limit, and `notes` is the core field it was written for. It is
 * expressed as the ceiling for any `textarea` value, because a second long-text field with a
 * different limit would be a second rule to keep in step with the database.
 */
export const MAX_NOTES_LENGTH = 5000;
/**
 * The same three numbers as a table, so a test can iterate them instead of naming each one and
 * quietly omitting the one that was added last.
 */
export const PRODUCT_CAPS = {
    activeImagesPerPerson: MAX_ACTIVE_IMAGES_PER_PERSON,
    adhocFieldsPerPerson: MAX_ADHOC_FIELDS_PER_PERSON,
    notesLength: MAX_NOTES_LENGTH,
};
//# sourceMappingURL=limits.js.map